import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';
import {AnnouncementService} from '../../pages/announcement/user/services/announcement.service';
import { FileApiService } from '../../shared/services/file-api/file-api.service';
import { SearchService } from '../../shared/components/search/services/search.service';
import { ShortcutService } from '../../shared/components/shortcut/service/shortcut.service';
import { AppMenuService } from '../../shared/services/menu/menu.service';
import { AuthUser } from '../../shared/services/auth/store/auth.models';
import { SidebarMenu } from '../sidebar/interface/sidebar-item';
import { SafeUrl } from '@angular/platform-browser';
import { PasswordChangePopupComponent } from '../../shared/components/password-change-popup/password-change-popup.component';
import { SidebarAnnouncementCanvasComponent } from '../../pages/announcement/user/sidebar-announcement/sidebar-announcement.component';

declare let $: any;

@Component({
  selector: 'app-header-secondary',
  standalone: false,

  templateUrl: './header-secondary.component.html',
  styleUrl: './header-secondary.component.scss'
})
export class HeaderSecondaryComponent{
  @ViewChild('passwordChangePopup')
  passwordChangePopup: PasswordChangePopupComponent;

  @ViewChild('coreMessagesUserCanvas')
  coreAnnouncementUserCanvas: SidebarAnnouncementCanvasComponent;

  user: AuthUser;
  headerMenu: SidebarMenu[] = [];
  openCall: any;
  station: string;
  minimizeCallCard: boolean = true;
  bobbleButton: boolean = true;
  token: string = '';
  photo: SafeUrl | null;
  isFullscreen = false;
  hasUnreadNotifications = false;

  constructor(
    private readonly authService: AuthService,
    private readonly menuService: AppMenuService,
    public router: Router,
    private readonly fileService: FileApiService,
    private readonly cdr: ChangeDetectorRef,
    private readonly searchService: SearchService,
    private readonly announcementService: AnnouncementService,
  ) {
    if(this.authService.getUserData()?.activeModule){
      this.menuService.fetchMenuModule(this.authService.getUserData()?.activeModule);
    }
    this.user = this.authService.getUserData();
    this.token = this.authService.getToken() ?? '';

  }

  ngOnInit() {
    this.authService.getAuthActions();

    this.authService.getAuthUser().subscribe({
      next: (res) => {
        const lastUpdate = new Date(res.passwordLastUpdate);
        const now = new Date();

        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(now.getMonth() - 3);

        if (lastUpdate < threeMonthsAgo) {
          this.passwordChangePopup.initilize(lastUpdate == null ? 'first' : 'last');
        }

        if (res?.staff?.photo?.fileUrl && this.token) {
          (async () => {
            try {
              const safeUrl = await this.fileService.getFileSafeUrl(
                res.staff.photo.fileUrl,
                this.token
              );
              this.photo = safeUrl;
              this.cdr.detectChanges?.();
            } catch (error) {
              console.error(error);
            }
          })();
        }
      },
    });

    this.menuService.getHeaderMenu().subscribe((response) => {
      this.headerMenu = response;
    });
    $.getScript('assets/theme/w3crm/js/deznav-init.js');

    this.station = localStorage.getItem('station') || '';

    const signedUserId = Number(this.authService.getUserId());
    // kullanıcıya atanmış duyurulardan okunmayan var ise icon üstü red bubble gözükmesi için status true olacak.
    this.announcementService
      .getByFilters({user: signedUserId})
      .subscribe((data: any) => {
        const visibleLoginAnnouncements: any[] =[];
        data.items?.map((i: any) => {
            const readStatus = i?.announcementReadStatuses?.find(
              (status: any) => status.user?.id === signedUserId
            );
            const isSignedUserRead = !!readStatus;
            if (!isSignedUserRead) {
              this.hasUnreadNotifications = true;
            }
            if (i?.reminderType?.id==1107 && !isSignedUserRead){
              visibleLoginAnnouncements.push(i);
            }
        });

        const allReadyLoginRead = data.items.filter((item:any)=>item?.reminderType?.id==1106);
        if (allReadyLoginRead){
          allReadyLoginRead.forEach((item:any)=>{
            visibleLoginAnnouncements.push(item);
          });
        }

        this.prepareQueueFromApi(visibleLoginAnnouncements);
      });
  }

  goToDashboard() {
    this.router.navigate(['/portal']);
  }

  handleItemClick(item: any): any {
    if (item.items.length == 0) {
      // Öğenin altında eleman yoksa ve url özelliği tanımlıysa, yönlendirme yap

      switch (item.urlType) {
        case 'ROUTE':
          if (item.targetBlank) {
            window.open(item.url);
          } else {
            this.router.navigate([item.url]);
          }
          break;
        case 'EXTERNAL':
          globalThis.location.href = item.url;
          break;
        case 'STATIC':
          globalThis.location.href = item.url;
          break;
      }
    }

    // Eğer öğenin altında başka öğeler varsa ve açıksa, kapat
    if (item.items.length > 0 && item.expanded) {
      item.expanded = false;
      item.active = '';
      item.ariaExpanded = false;
      item.mmShow = '';
    } else if (item.items.length > 0) {
      // Eğer öğenin altında başka öğeler varsa ve kapalıysa, aç
      item.expanded = true;
      item.active = 'mm active';
      item.ariaExpanded = true;
      item.mmShow = 'mm-show';
    }
  }

  async logout() {
    await this.authService.logout(); // Servis zaten temizliği ve isteği yapıyor
  }


  getShownAnnouncements(): number[] {
    const data = localStorage.getItem('loginAnnouncement');
    return data ? JSON.parse(data) : [];
  }

  addShownAnnouncement(id: number) {
    const shown = this.getShownAnnouncements();

    if (!shown.includes(id)) {
      shown.push(id);
      localStorage.setItem('loginAnnouncement', JSON.stringify(shown));
    }
  }

  prepareQueueFromApi(list: any[]) {
    const shownIds = this.getShownAnnouncements();
    const newAnnouncements = list.filter(a => !shownIds.includes(a.id));

    if (newAnnouncements.length) {
      this.coreAnnouncementUserCanvas.openAnnouncementArray(newAnnouncements);
      newAnnouncements.forEach(a=>{
        this.addShownAnnouncement(a.id);
      })
    }
  }

  openMessagesSidebar() {
    this.coreAnnouncementUserCanvas.openPopup();
  }


  toggleFullscreen(): void {
  const elem = document.documentElement;

  if (this.isFullscreen) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
    this.isFullscreen = false;
  } else {

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if ((elem as any).webkitRequestFullscreen) {
      (elem as any).webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) {
      (elem as any).msRequestFullscreen();
    }
    this.isFullscreen = true;
  }
}


openSearch() {
  this.searchService.triggerSearch();
}


}
